<template>
    <div class="formulation-form-row">
        <div class="col-4 ">
            <select :disabled="viewMode" v-model="formTraceElements[rowIndex].name" @change="onSelectElement($event)" class="form-control">
                <option class="d-none" value="">- Select -</option>
                <option value="none">Not Required</option>
                <optgroup label="Multi">
                    <option v-for="(item, index) in elementsList.multi" :value="item.label" v-bind:key="index" :disabled="checkDisabled(item, 'multi')">
                        {{ item.label }}
                    </option>
                </optgroup>
                <optgroup label="Single">
                    <option v-for="(item, index) in elementsList.single" :value="item.label" v-bind:key="index" :disabled="checkDisabled(item, 'single')">
                        {{getSingleItemLabel(item)}}
                    </option>
                </optgroup>
            </select>
            <div class="clear">
                <button v-if="!viewMode && formTraceElements.length > 1" class="list-item-remove" v-on:click="removeRow" >Remove</button>
            </div>
            <template v-if="errorMulti">
                <span class="form-error general" v-for="(item, index) in errorMulti" :key="index">{{item}}</span>
            </template>
        </div>
        <div class="col-3" v-if="selectedItem">
            <input :disabled="viewMode" type="number" min="0" step="any" class="form-control" v-model="formTraceElements[rowIndex].value" @input="onInputChanged" @keydown="$event.key === '-' ? $event.preventDefault() : null">
            <span class="form-uom" v-if="selectedItem">
                <template v-if="selectedItem.unit">{{selectedItem.unit}}</template>
                <template v-else>
                    <template v-if="micronutrientsUnit === 'microgram'">&micro;g</template>
                    <template v-if="micronutrientsUnit === 'micromol'">&micro;mol</template>
                </template>
            </span>
            <span class="form-uom" v-if="selectedItem"></span>
            <span class="form-error" v-if="error">Outside guidelines for stability</span>
        </div>
        <div class="col-5" v-if="rowItem.value && rowItem.type === 'multi'">
            <div class="formulation-table">
                <table>
                    <template v-for="(item, index) in getItemComposition()">
                        <tr :key="index">
                            <td class="text-left">{{item.label}}</td>
                            <td class="text-right" v-if="micronutrientsUnit === 'microgram'">{{ formatNumber(item.microgram * parseFloat(rowItem.value), 2) }}</td>
                            <td class="text-right" v-if="micronutrientsUnit === 'micromol'">{{ formatNumber(item.micromol * parseFloat(rowItem.value), 2) }}</td>
                            <td>
                                <template v-if="micronutrientsUnit === 'microgram'">&micro;g</template>
                                <template v-if="micronutrientsUnit === 'micromol'">&micro;mol</template>
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
    </div>
</template>


<script>

// import { required, requiredIf } from 'vuelidate/lib/validators';
import tpnUtilsMixin from '@/mixins/tpnUtilsMixin';

export default {
    name: 'MicronutrientTraceElementRow',
    mixins: [tpnUtilsMixin],
    components: {
    },
    props: {
        rowIndex: {
            required: true,
        },
        rowItem: {
            required: true,
        },
        elementsList: {
            required: true,
        },
        formTraceElements: {
            required: true,
        },
        micronutrientsUnit: {
            required: true,
        },
        settings: {
            required: true,
        },
        country: {
            required: true,
        },
        error: {
            required: false,
        },
        errorMulti: {
            required: false,
        },
        viewMode: {
            required: true,
        },
    },
    data() {
        return {
            allElements: [],
            selectedItem: false,
        };
    },
    created() {
        this.elementsList.multi.forEach((item) => {
            this.allElements.push({ ...item, type: 'multi' });
        });
        this.elementsList.single.forEach((item) => {
            this.allElements.push({ ...item, type: 'single' });
        });

        this.setSelectedItem();
    },
    updated() {
        this.setSelectedItem();
    },
    methods: {
        setSelectedItem() {
            if (this.rowItem.name) {
                const selectedItem = this.allElements.find((item) => item.label === this.rowItem.name);
            this.selectedItem = selectedItem;
            }
        },
        getSingleItemLabel(item) {
            let { label } = item;
            if (label === 'Iron as Dextran') {
                if (this.country === 'Australia') {
                    label += ' [SAS]';
                }
                if (this.country === 'New Zealand') {
                    label += ' [S29]';
                }
            }
            return label;
        },
        getItemComposition() {
            const teinfo = this.settings.find((el) => el.label === this.rowItem.name);
            if (teinfo) {
                return teinfo.composition;
            }
            return false;
        },
        onInputChanged() {
            this.$emit('resetStability');
            this.$emit('updateTraceElementTotals');
        },
        onSelectElement(event) {
            const { value } = event.target;
            // search selected element
            const selectedItem = this.allElements.find((item) => item.label === value);

            // handle composition
            if (selectedItem) {
                this.formTraceElements[this.rowIndex].type = selectedItem.type;
                this.formTraceElements[this.rowIndex].unit = false;
                this.selectedItem = selectedItem;
                if (selectedItem.unit) {
                    this.formTraceElements[this.rowIndex].unit = selectedItem.unit;
                }
            } else {
                this.selectedItem = false;
                this.formTraceElements[this.rowIndex].unit = false;
                this.formTraceElements[this.rowIndex].type = false;
            }

            // reset value
            this.formTraceElements[this.rowIndex].value = '';
            // reset error
            this.$emit('resetTEError', this.rowIndex);

            this.$emit('resetStability');
            this.$emit('updateTraceElementTotals');
        },
        removeRow() {
            this.formTraceElements.splice(this.rowIndex, 1);
            this.$emit('resetStability');
            this.$emit('removeTEError', this.rowIndex);
            this.$emit('updateTraceElementTotals');
        },
        getUnit() {
            if (this.selectedItem.unit) {
                return this.selectedItem.unit;
            }
            if (this.micronutrientsUnit === 'microgram') {
                return '&micro;g';
            }
            if (this.micronutrientsUnit === 'micromol') {
                return '&micro;mol';
            }
            return '';
        },
        checkDisabled(item, type) {
            const elementsSubset = this.formTraceElements.slice();
            elementsSubset.splice(this.rowIndex, 1);

            // const prevItems = this.formTraceElements.slice(0, this.rowIndex);
            if (elementsSubset.find((el) => el.name === item.label)) {
                return true;
            }

            // only 1 multi
            if (type === 'multi') {
                const multi = elementsSubset.find((el) => el.type === 'multi');
                if (multi) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>
